

import * as Js_exn from "@rescript/std/lib/es6/js_exn.js";
import * as Caml_option from "@rescript/std/lib/es6/caml_option.js";
import * as Caml_exceptions from "@rescript/std/lib/es6/caml_exceptions.js";
import * as Caml_js_exceptions from "@rescript/std/lib/es6/caml_js_exceptions.js";

var ParseError = /* @__PURE__ */Caml_exceptions.create("Json.ParseError");

function parse(s) {
  try {
    return Caml_option.some(JSON.parse(s));
  }
  catch (exn){
    return ;
  }
}

function parseOrRaise(s) {
  try {
    return JSON.parse(s);
  }
  catch (raw_e){
    var e = Caml_js_exceptions.internalToOCamlException(raw_e);
    if (e.RE_EXN_ID === Js_exn.$$Error) {
      var m = e._1.message;
      var message = m !== undefined ? m : "Unknown error";
      throw {
            RE_EXN_ID: ParseError,
            _1: message,
            Error: new Error()
          };
    }
    throw e;
  }
}

var Decode;

var Encode;

function stringify(prim) {
  return JSON.stringify(prim);
}

export {
  Decode ,
  Encode ,
  ParseError ,
  parse ,
  parseOrRaise ,
  stringify ,
}
/* No side effect */
